/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type GetJobSequenceAnalyticsParams = {
/**
 * @minimum 1
 * @maximum 365
 */
days?: number;
/**
 * @maxLength 64
 */
tz?: string;
};
